
import { Vue } from "vue-class-component";

export default class LeftSideBar extends Vue {
  private onClick(): void {
    this.$router.push("/");
  }
}
